import { Spinner } from "react-bootstrap";
import styles from "./LoadingButton.module.css";

function LoadingButton({
  title = "",
  className = "",
  center = false,
  ...props
}) {
  return (
    <button
      className={"btn" + (className ? " " + className : "")}
      type="button"
      {...props}
    >
      <div
        className={
          "d-flex align-items-center" +
          (center ? " justify-content-center column-gap-1" : "")
        }
      >
        <Spinner className={styles.spinner} />

        <span className="me-1">{title}</span>
      </div>
    </button>
  );
}

export default LoadingButton;
